const PATHS = {
  APPLICATION: 'application',
  ASSETS: 'assets',
  SELF_IDENTIFICATION: 'self-identification',
  WELCOME: 'welcome',
  DASHBOARD: 'dashboard',
  HOUSEHOLD: 'household',
  VERIFICATION: 'verification',
  CREDIT_CRIMINAL_CHECK: 'credit-criminal-check',
  IDENTIFYING_DETAILS: 'identifying-details',
  DOCUMENTATION: 'documentation',
  DOCUMENTS_AND_UPLOADS: 'documents-and-uploads',
  APPLICATION_SUBMISSION: 'application-submission',
  MARITAL_STATUS: 'marital-status',
  MOVE_IN: 'move-in',
  PAYMENTS: 'payments',
  WAGES_AND_INCOME: 'wages-and-income',
  DEDUCTIONS: 'deductions',
};

export const DOCUMENTS_AND_UPLOADS_PATHS = {
  OVERVIEW: 'overview',
  TASK_LIST: 'task-list',
};

export const APPLICATION_SUBMISSION_PATHS = {
  SIGNATURE_AND_REPRESENTATION: 'signature-and-representation',
  SUMMARY: 'summary',
};

export const HOUSEHOLD_PATHS = {
  MEMBERS: 'members',
  DESIGNATION: 'designation',
  MARITAL_STATUS: 'marital-status',
  MINOR_RELATIONSHIP: 'minors-relationship',
  STUDENT_STATUS: 'student-status',
  FULL_TIME_STUDENT: 'full-time-student',
  RD_STUDENT_STATUS: 'rd-student-status',
  HUD_HOME_STUDENT_STATUS: 'hud-home-student-status',
  ADDITIONAL_MINORS: 'additional-minors',
  PREFERENCES_1: 'preferences-1',
  PREFERENCES_2: 'preferences-2',
  PREFERENCES_3: 'preferences-3',
  PREFERENCES_4: 'preferences-4',
  DEMOGRAPHICS: 'demographics',
  LIVE_IN_AIDE: 'live-in-aide',
  SUMMARY: 'summary',
  INVITE: 'invite',
};

export const PAYMENTS_PATHS = {
  OVERVIEW: 'overview',
  FORM: 'form',
  RECEIPT: 'receipt',
};

export const IDENTIFYING_DETAILS_PATHS = {
  OVERVIEW: 'overview',
  IDENTIFICATION: 'identification',
  IDENTIFICATION_ALTERNATE: 'identification-alternate',
  HUD_CITIZENSHIP: 'hud-citizenship',
  RESIDENTIAL_HISTORY: 'residential-history',
  BACKGROUND: 'background',
  SUMMARY: 'summary',
};

export const CREDIT_CRIMINAL_CHECK_PATHS = {
  MIDDLE_NAMES_AND_SUFFIXES: 'middle-names-and-suffixes',
  MOVE_IN_PREFERENCES: 'move-in-preferences',
  CONSENT: 'consent',
  SUMMARY: 'summary',
  COMPLETE: 'complete',
};

export const RESIDENTIAL_HISTORY_PATHS = {
  CURRENT: 'current',
  PREVIOUS: 'previous',
  LIVE_TOGETHER: 'live-together',
};

export const WAGES_AND_INCOME_PATHS = {
  CHOICES_1: 'choices-1',
  CHOICES_2: 'choices-2',
  CHOICES_3: 'choices-3',
  CHOICES_4: 'choices-4',
  NO_INCOME: 'no-income',
  CURRENT_JOB: 'job',
  ANTICIPATED_JOB: 'anticipated',
  LAST_JOBS: 'last-job',
  CHILD_SUPPORT: 'child-support',
  ALIMONY: 'alimony',
  SOCIAL_SECURITY: 'social-security',
  OTHER_INCOME: 'other',
  PUBLIC_ASSISTANCE: 'public',
  GIFTS: 'gift',
  UNEMPLOYMENT: 'unemployment',
  PENSION: 'pension',
  VA_BENEFITS: 'va-benefits',
  ONLINE: 'online',
  TRUST: 'trust',
  UNEARNED: 'unearned',
  RENTAL_ASSISTANCE: 'rental-assistance',
  OVERVIEW: 'overview',
  SUMMARY: 'summary',
};

export const ASSETS_PATHS = {
  OVERVIEW: 'overview',

  CHOICES_1: 'choices-1',
  CHOICES_2: 'choices-2',
  CHOICES_3: 'choices-3',
  CHOICES_4: 'choices-4',

  CASH: 'cash',
  CHECKINGS: 'checkings',
  PAYCARD: 'paycard',
  CERTIFICATES: 'certificates',
  FEDERAL_TAX_REFUND_CREDIT: 'federal-tax-refund-credit',
  TRUST: 'trust',
  TREASURY_BILLS: 'treasury-bills',
  STOCKS: 'stocks',
  RETIREMENT: 'retirement',
  LIFE_INSURANCE: 'life-insurance',
  SOLD_ASSET: 'sold-assets',
  PROPERTY: 'property-investment',
  REAL_ESTATE: 'real-estate',
  OTHER_ASSETS: 'other-assets',

  SUMMARY: 'summary',
};

export const DEDUCTIONS_PATHS = {
  OVERVIEW: 'overview',
  CHOICES: 'choices',
  CHILDCARE_TO_WORK: 'childcare-to-work',
  CHILDCARE_TO_SCHOOL_OR_WORK_SEARCH: 'childcare-to-school-or-work-search',
  OUT_OF_POCKET_DISABILITY: 'out-of-pocket-disability',
  OUT_OF_POCKET_MEDICAL: 'out-of-pocket-medical',
  SUMMARY: 'summary',
};

export const SELF_IDENTIFICATION_PATHS = {
  ADDITIONAL_DETAILS: 'additional-details',
  VEHICLES: 'vehicles',
  PETS: 'pets',
  EMERGENCY_CONTACTS: 'emergency-contacts',
  SELF_IDENTIFICATION: 'self-identification',
  HUD_CITIZENSHIP: 'hud-citizenship',
  APPLICATION_ASSISTANCE: 'application-assistance',
};

export const UNINVITED_SECONDARY_USER_PATHS = {
  [IDENTIFYING_DETAILS_PATHS.IDENTIFICATION]: `${PATHS.IDENTIFYING_DETAILS}/${IDENTIFYING_DETAILS_PATHS.IDENTIFICATION}`,
  [IDENTIFYING_DETAILS_PATHS.HUD_CITIZENSHIP]: `${PATHS.IDENTIFYING_DETAILS}/${IDENTIFYING_DETAILS_PATHS.HUD_CITIZENSHIP}`,
  [CREDIT_CRIMINAL_CHECK_PATHS.CONSENT]: `${PATHS.CREDIT_CRIMINAL_CHECK}/${CREDIT_CRIMINAL_CHECK_PATHS.CONSENT}`,
  [SELF_IDENTIFICATION_PATHS.SELF_IDENTIFICATION]: `${PATHS.SELF_IDENTIFICATION}/${SELF_IDENTIFICATION_PATHS.SELF_IDENTIFICATION}`,
  [DOCUMENTS_AND_UPLOADS_PATHS.OVERVIEW]: `${PATHS.DOCUMENTS_AND_UPLOADS}/${DOCUMENTS_AND_UPLOADS_PATHS.OVERVIEW}`,
  [DOCUMENTS_AND_UPLOADS_PATHS.TASK_LIST]: `${PATHS.DOCUMENTS_AND_UPLOADS}/${DOCUMENTS_AND_UPLOADS_PATHS.TASK_LIST}`,
  [APPLICATION_SUBMISSION_PATHS.SIGNATURE_AND_REPRESENTATION]: `${PATHS.APPLICATION_SUBMISSION}/${APPLICATION_SUBMISSION_PATHS.SIGNATURE_AND_REPRESENTATION}`,
};

export default PATHS;
